import React from 'react'
import ReactTable from "react-table";
import axios from 'axios'
import {getToken, setLocalKeyValue, getLocalKeyValue, getUserSettings, getDateRange} from '../../storage'
import {API_BASE_URL, PURCHASE_LIST_PAGE_SIZE} from '../../constants'
import {DRN} from '../report/daterange'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import DateFormat from '../../utils/dateformat'
import _ from 'lodash'
import {Summation} from '../commons/tablefooters'
import {updateHistory} from '../commons/functions'
import SearchInput from '../search/search'
export default class Purchases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange : getDateRange(),
      data: [],
      pages: null,
      loading: true,
      supplier: props.location.state ? (props.location.state.supplier || null): null,
      item: props.location.state ? (props.location.state.item || null): null,
      purchase_search: props.location.state ? (props.location.state.purchase_search || null): null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreatePurchase = this.goToCreatePurchase.bind(this)
    this.getItems = this.getItems.bind(this)
    this.getSuppliers = this.getSuppliers.bind(this)
    this.renderSupplierName = this.renderSupplierName.bind(this)
    this.handleSupplierChange = this.handleSupplierChange.bind(this)
    this.handleItemChange = this.handleItemChange.bind(this)
    document.title = "Purchases List"
  }
  goToCreatePurchase(e) {
    e.preventDefault()
    this.props.history.push("/purchases/create/")
  }
  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/purchases/edit/'+row.original.serial)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  handleSupplierChange(value) {
    this.setState({supplier: value})
    this.fetchData(this.state.tableState, {}, value, this.state.item)
    updateHistory(this.props, {supplier:value})
  }
  handleItemChange(value) {
    this.setState({item: value})
    this.fetchData(this.state.tableState, {}, this.state.supplier, value)
    updateHistory(this.props, {item:value})
  }



    downloadReport = (report_type) => {
      return   axios({
        url: report_type,
        method: 'get',
        responseType: 'blob',
        onDownloadProgress: progressEvent => {
          let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          this.setState({downloadPercent:percentCompleted})
        },
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      })
    }



    downloadRatePurchases = (xls_url) =>{
      this.setState({downloading_invoices:true,})

      let apiurl = xls_url
      let dateRange = this.state.dateRange
      if(dateRange) {
        let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
        let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
        let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
        let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
        apiurl = apiurl + "?start_date="+start_date+"&end_date="+end_date
      }
      let item = this.state.item
      if(typeof item !== "undefined" && item !== null) {
        apiurl = apiurl + '&item_id='+item.id
      }
      let supplier  = this.state.supplier
      if(typeof supplier !== "undefined" && supplier !== null) {
        apiurl = apiurl + '&supplier_id='+supplier.id
      }
      let purchase_search = this.state.purchase_search
      if(purchase_search) {
        apiurl = apiurl + "&purchase_search="+purchase_search
      }

      this.downloadReport(apiurl).then((response)=> {
        this.setState({submitting_rate_sales:false})

        let disposition = response.headers['content-disposition']
        let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        this.setState({downloadPercent:undefined})
      }).catch((err)=> {
        this.setState({submitting_rate_sales:false, downloadPercent:undefined})
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

        }
      })
    }


  getSuppliers (input) {

    if(!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_suppliers/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.suppliers}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}
getItems (input) {

  if(!input) {
    return Promise.resolve({ options: [] });
  }

  return   axios({
      url: '/list_items/?q='+input,
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
          return {options: response.data.items}
    }).catch((err)=> {
      return Promise.resolve({ options: [] });
    })
}


  renderSupplierName(option){
    return <span>{option.name} {option.city}</span>
  }

  fetchData(state, instance, supplier=this.state.supplier, item=this.state.item, dateRange=this.state.dateRange, purchase_search=this.state.purchase_search) {

    this.setState({ loading: true });
    setLocalKeyValue(PURCHASE_LIST_PAGE_SIZE, state.pageSize)
    let apiurl = "/list_purchases/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    if(typeof supplier !== "undefined" && supplier !== null) {
      apiurl = apiurl + '&supplier_id='+supplier.id
    }
    if(typeof item !== "undefined" && item !== null) {
      apiurl = apiurl + '&item_id='+item.id
    }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    if(purchase_search) {
      apiurl = apiurl + "&purchase_search="+purchase_search
    }
    this.setState({tableState:state, supplier:supplier, item:item, dateRange:dateRange, purchase_search:purchase_search})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.purchases,
        pages: res.data.pages,
        total_tax_value:res.data.total_tax_value.totalTax__sum,
        total_amount_value:res.data.total_amount_value.totalPrice__sum,
        total_purchase_value:res.data.total_purchase_value.total__sum,
        total_quantity_value:res.data.total_quantity_value.purchaseitem__quantity__sum,
        loading: false
      });
    });
  }

  supplierNameFormat(row) {

    if(row.original.supplier !== null) {
      const supplier = row.original.supplier
      return <div>{supplier.name} {supplier.city}</div>
    }
    else {
      return null
    }
  }

  // renderTotalTax(row) {
  //   return  <div className="text-right">{parseFloat(parseFloat(row.original.totalTax) + parseFloat(row.original.totalCess)).toFixed(2)}</div>
  // }

  renderTotalTax(row) {

    let item = this.state.item
    if(!item) {
      return  <div className="text-right">{parseFloat(parseFloat(row.original.totalTax) + parseFloat(row.original.totalCess)).toFixed(2)}</div>

    }
    else {
        let matchedItems = row.original.purchaseitem_set.filter((pitem)=>pitem.item === item.id)
        let gst=0
        matchedItems.forEach((i,id)=>{

          gst = gst + parseFloat(i.igst_amount) + parseFloat(i.cess_amount) + parseFloat(i.specific_cess_amount)
        })
        return <div className="text-right">{parseFloat(gst).toFixed(2)}</div>
    }

  }

  amountFormat = (row) =>{
    let item = this.state.item
    if(!item) {
        return <div className="text-right">{row.original.totalPrice}</div>
    }
    else {
        let matchedItems = row.original.purchaseitem_set.filter((pitem)=>pitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.price)
        })
        return <div className="text-right">{parseFloat(p).toFixed(2)}</div>
    }
  }

  quantityFormat = (row)=>{
    let item = this.state.item
    if(!item) {
        return <div className="text-right">{_.sum(_.map(row.original.purchaseitem_set, i=>{return parseFloat(i.quantity)}))}</div>
    }
    else {
        let matchedItems = row.original.purchaseitem_set.filter((pitem)=>pitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.quantity)
        })
        return <div className="text-right">{p}</div>
    }
  }

  cstQuantityFormat = (row)=>{
    let item = this.state.item
    if(!item) {
       let sorted_set = row.original.purchaseitem_set.sort((a,b)=>{
         return b.quantity - a.quantity
       })

        return <div className="text-right">{parseFloat(sorted_set[0].quantity).toFixed(2) }</div>
    }
    else {
        let matchedItems = row.original.purchaseitem_set.filter((pitem)=>pitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.quantity)
        })
        return <div className="text-right">{p}</div>
    }
  }


  applyDateRange = (dateRange) => {
    this.fetchData(this.state.tableState, {}, this.state.supplier, this.state.item, dateRange)
  }

  handleSearchPurchase = (q) => {
    this.fetchData(this.state.tableState, {}, this.state.supplier, this.state.item, this.state.dateRange, q)
    updateHistory(this.props, {purchase_search:q})
  }


    totalFormat = (row) =>{
      let item = this.state.item
      if(!item) {
          return <div className="text-right">{row.original.total}</div>
      }
      else {
          let matchedItems = row.original.purchaseitem_set.filter((pitem)=>pitem.item === item.id)
          let p=0
          matchedItems.forEach((i,id)=>{
            p = p + parseFloat(i.total)
          })
          return <div className="text-right">{parseFloat(p).toFixed(2)}</div>
      }
    }



  render() {

    let settings = getUserSettings()

    let options
    if(settings && settings.options) {
      options = settings.options
    }

    let xls_url = "/export_purchases_excel/"

    const { data, pages, loading } = this.state;

    let total_purchase_value, total_tax_value, total_amount_value, total_quantity_value
    if(this.state.total_purchase_value) {
      total_purchase_value = parseFloat(this.state.total_purchase_value).toFixed(2)
    }
    if(this.state.total_tax_value) {
      total_tax_value = parseFloat(this.state.total_tax_value).toFixed(2)
    }
    if(this.state.total_amount_value) {
      total_amount_value = parseFloat(this.state.total_amount_value).toFixed(2)
    }
    if(this.state.total_quantity_value) {
      total_quantity_value = parseFloat(this.state.total_quantity_value).toFixed(2)
    }

    let columns = []

    columns.push({Header:'Date', accessor: 'date', sortable:true, Cell:(row)=>(<DateFormat date={row.original.date}/>)},
    {Header:'Bill No', accessor: 'supplier_bill_no', sortable:true},
    {Header:'Supplier', accessor: 'supplier__name',sortable:true, Cell:(row)=>{return this.supplierNameFormat(row)} })

    if(options) {

      if(options.column_purchase_created) {
        columns.splice(1,0, {Header:'Created', accessor: 'created', sortable:true,
           Cell:(row)=>(<DateFormat date={row.original.created}/>)})
      }

      if(options.purchase_table_col_quantity) {
        columns.push({Header:'Quantity',  accessor:'quantity',sortable:true,
          Footer:()=>{
            if(this.state.item) {
              return <Summation innerArray="purchaseitem_set" data={data}
                innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
                fields={['quantity']}  />
            }
            else {
              return <Summation innerArray="purchaseitem_set" data={data} field="quantity" full_sum={total_quantity_value}  />
            }
          },
           Cell:(row)=>{return options.cst_purchase_quantity ? this.cstQuantityFormat(row) : this.quantityFormat(row)} })
      }
      if(options.purchase_xls_download_format === "format_b") {
        xls_url = "/export_purchases_excel_format_b/"
      }
    }

    columns.push({Header:'Amount',  accessor:'totalPrice',sortable:true,
      Footer: ()=>{
        if(this.state.item) {
            return (<Summation data={data} fields={['price']} innerArray="purchaseitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}  />)
        }
        else {
            return <Summation data={data} field="totalPrice" full_sum={total_amount_value} />
        }

      },
       Cell:(row)=>{return this.amountFormat(row)} },
    {Header:'Tax',  accessor:'totalTax', sortable:true,
      Footer: ()=>{
        if(this.state.item) {
          return <Summation data={data} innerArray="purchaseitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
             fields={['igst_amount', 'cess_amount', 'specific_cess_amount']}  />
        }
        else {
            return <Summation data={data} field="totalTax" fields={['totalTax', 'totalCess']} full_sum={total_tax_value} />
        }
      },
       Cell:(row)=>{return this.renderTotalTax(row)} },
    {Header:'Total',  accessor:'total', sortable:true,
      Footer: ()=>{
        if(this.state.item) {
          return <Summation data={data} fields={['total']} innerArray ="purchaseitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
             />
        }
        else {
          return <Summation data={data} field="total" full_sum={total_purchase_value} />
        }
      },

       Cell:(row)=>{return this.totalFormat(row)} },)

    if(options) {
      if(options.created_and_modified_user_info) {
        columns.push({Header:'Created By', Cell:(row)=>(<div className="text-center">{ row.original.created_by ? row.original.created_by.username: ""}</div>)})
        columns.push({Header:'Modified By', Cell:(row)=>(<div className="text-center">{ row.original.modified_by ? row.original.modified_by.username: ""}</div>)})
      }
    }

    const defaultSort=[{id: "date", desc: true}]

    let pageSize = getLocalKeyValue(PURCHASE_LIST_PAGE_SIZE)

    if(typeof pageSize === "undefined"){
      pageSize = 20
    }
    else {
      pageSize = parseInt(pageSize, 10)
    }



    return <div><section className="medium">

      <div className="row">
      <div className="col-sm-2">
      <button onClick={this.goToCreatePurchase} className="btn btn-primary">Create New Purchase</button>
      </div>

      <div className="col-sm-7">
          <div className="row">
              <div className="col-sm-4">
                <SearchInput value={this.state.purchase_search} handleSearchInput={this.handleSearchPurchase} placeholder={"Search Bill No"} />
              </div>
              <div className="col-sm-4">
                <Select.Async multi={false} onChange={this.handleSupplierChange} valueRenderer={this.renderSupplierName}
                optionRenderer={this.renderSupplierName} value={this.state.supplier} valueKey="id" labelKey="name"
                loadOptions={this.getSuppliers} backspaceRemoves={true} placeholder="Select Supplier"/>
              </div>
              <div className="col-sm-4">
                <Select.Async multi={false} onChange={this.handleItemChange}
                value={this.state.item} valueKey="id" labelKey="name"
                loadOptions={this.getItems} backspaceRemoves={true} placeholder="Select Item"/>
              </div>
          </div>
      </div>
      <div className="col-sm-3">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
      </div>

      </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadRatePurchases(xls_url)}}>Download xls</button></div>
          <ReactTable defaultSorted={defaultSort}
            getTrProps={this.handleTrclick}
            noDataText="No Purchases Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize} />
        </div>

      </div>
    </div>

    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/purchaselist.js